import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";

import useStyles from "assets/jss/material-dashboard-react/components/inputStyle";
import ErrorMessage from "@Components/ErrorMessage";
import { InputAdornment, IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const Input = (props) => {
  const { t } = useTranslation();
  const classesInner = useStyles();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const {
    label,
    name,
    required,
    labelClasses,
    errorMessage,
    password,
    ...rest
  } = props;
  return (
    <>
      <InputLabel
        htmlFor={name}
        className={clsx(classesInner.label, {
          [classesInner.error]: errorMessage,
          [labelClasses]: labelClasses,
        })}
      >
        {t(label)}
        {required ? <span style={{ color: "red" }}> *</span> : null}
      </InputLabel>
      <TextField
        style={{ marginBottom: 8 }}
        name={name}
        type={password ? (showPassword ? "text" : "password") : "text"}
        variant="outlined"
        {...rest}
        InputLabelProps={{ shrink: true }}
        fullWidth
        size="small"
        InputProps={
          password
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : null
        }
      />
      <ErrorMessage message={errorMessage} />
    </>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  labelClasses: PropTypes.string,
  required: PropTypes.bool,
  classes: PropTypes.string,
  name: PropTypes.string,
  errorMessage: PropTypes.array,
  field: PropTypes.object,
  meta: PropTypes.object,
  password: PropTypes.bool,
};

export default Input;
